import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterData',
  pure: true,
  standalone: true
})
export class FilterDataPipe implements PipeTransform {
  transform(items: any[], filter: string, valuePrimitive?: boolean, prop?: string): any {
    if (!items || !filter) {
      return items;
    }
    if (valuePrimitive) {
      return items.filter((item) => {
        const val = item.toLowerCase();
        return val.includes(filter?.toLowerCase())
      });
    } else {
      if (prop) {
        if (typeof prop === 'function') {
          return items.filter(prop);
        }
        return items.filter((item) => {
          const val = item[prop]?.toLowerCase();
          return val?.includes(filter?.toLowerCase())
        });
      }
      return items.filter((item) => {
        const val = item.value?.toLowerCase();
        return val?.includes(filter?.toLowerCase())
      });
    }
  }
}
